import React, { useEffect, useState } from 'react';
import meme1 from '../assets/meme1.png';
import meme2 from '../assets/meme2.png';
import styled from 'styled-components';

const MemeImage = styled.img`
  position: absolute;
  width: 50px;
  height: 50px;
  pointer-events: none;
`;

const MemeEffect = ({ onEffectEnd }) => {
  const [positions, setPositions] = useState([]);
  const [effectActive, setEffectActive] = useState(true);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (effectActive && Math.random() > 0.7) {
        setPositions((prev) => [
          ...prev,
          { x: e.clientX, y: e.clientY, image: Math.random() > 0.5 ? meme1 : meme2 }
        ]);
      }
    };

    const startEffect = () => {
      document.addEventListener('mousemove', handleMouseMove);

      setTimeout(() => {
        setEffectActive(false);
        document.removeEventListener('mousemove', handleMouseMove);
        onEffectEnd();
      }, 4000);
    };

    startEffect();

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [effectActive, onEffectEnd]);

  return (
    <>
      {positions.map((pos, index) => (
        <MemeImage
          key={index}
          src={pos.image}
          style={{ left: `${pos.x}px`, top: `${pos.y}px` }}
        />
      ))}
    </>
  );
};

export default MemeEffect;
